/**
 * See https://en.wikipedia.org/wiki/Linear_interpolation#Programming_language_support
 * @param a - the value at t=0
 * @param b - the value at t=1
 * @param t - a proportion on the unit interval [0, 1] used to scale
 * linearly between a and b.
 * @returns - a value between a and b determined by the magnitude of
 * t.
 */



export const lerp = (a: number, b: number, t: number) => {
    return (1 - t) * a + t * b;
};
// The rest are easing functions: https://easings.net/

export const easeInOutSine = (x: number) => {
    return -(Math.cos(Math.PI * x) - 1) / 2;
};

export const easeInExpo = (x: number) => {
    return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
};
